import { render, staticRenderFns } from "./TaxInfo.vue?vue&type=template&id=1df82a06&scoped=true"
import script from "./TaxInfo.vue?vue&type=script&lang=js"
export * from "./TaxInfo.vue?vue&type=script&lang=js"
import style0 from "./TaxInfo.vue?vue&type=style&index=0&id=1df82a06&prod&lang=css"
import style1 from "./TaxInfo.vue?vue&type=style&index=1&id=1df82a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df82a06",
  null
  
)

export default component.exports